module.exports = __webpack_public_path__ + "static/media/CBON - Community based organization Network desktop - CBON - 22-11-2024 C.32876b55.gif";